/**
 * ******************************************
 * Designed to be used with views/Campaigns/Campaigns.tsx
 * If you have a more customized design for your use case.
 * Build your own and practice component composition.
 * ******************************************
 */
import React from 'react'

// My components
import AppBar from 'components/AppBar/AppBar'
import AppBarTitleSection from 'components/AppBar/AppBarTitleSection'
import AppBarToolbar from 'components/AppBar/AppBarToolbar'
import AppBarTitle from 'components/AppBar/AppBarTitle'
import AppBarTitleSectionFilter from 'components/AppBar/AppBarTitleSectionFilter'
import ToolbarDrawerIconButon from 'components/AppBar/ToolbarDrawerIconButon'
import Account from 'models/Account'
import AccountFilter from 'components/Settings/Filter/AccountFilter'

export default function SettingsAppBar() {
  return (
    <AppBar>
      <AppBarTitleSection>
        <AppBarToolbar>
          <ToolbarDrawerIconButon />
          <AppBarTitle>Settings</AppBarTitle>
        </AppBarToolbar>
        <AccountFilter />
      </AppBarTitleSection>
    </AppBar>
  )
}
